export default "__VITE_ASSET__CgiughfJ__"